import React, { useEffect } from "react";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import he from "he";

const QuillEditor = ({ value, onChange }) => {
  const { quill, quillRef } = useQuill({
    theme: "snow",
    modules: {
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
      ],
    },
  });

  /** İçerik değiştiğinde dışarı aktar */
  useEffect(() => {
    if (!quill) return;

    quill.on("text-change", () => {
      const html = quill.root.innerHTML;

      // Boş Quill çıktısını temizle (default: <p><br></p>)
      if (html === "<p><br></p>") {
        onChange("");
      } else {
        onChange(html);
      }
    });
  }, [quill, onChange]);

  /** Props’tan gelen value editöre set edilirken decode yap */
  useEffect(() => {
    if (!quill) return;
    if (value == null) return; // undefined / null kontrolü

    const decoded = he.decode(value || "");

    if (decoded !== quill.root.innerHTML) {
      quill.root.innerHTML = decoded;
    }
  }, [value, quill]);

  return <div style={{ height: 300 }} ref={quillRef} />;
};

export default QuillEditor;
